import axios from 'axios';
// import { getAuthHeader } from '../config/Utils';


const getAuthHeader = () => {
    const token = sessionStorage.getItem('token');
    const header = {
        headers: { 
            Authorization: "Bearer " + token
     }
    };
    return header;
}

export const getUserProfileDetail = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/student-profile-details`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getCountryCode = async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/country-code`
    return axios.post(url,{cid:cid},getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const uploadProfile = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/update-profile-image`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getTargetExam = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/course-categories`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getTShirtSize = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/tshirt-size`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getAdmissionMode = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/admission-modes`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getCurriculums = async(cid) => {
    const url = `${process.env.REACT_APP_API_URL}/api/curriculums`
    return axios.post(url,{cid:cid},getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getStudentFee = async(id) => {
    const url = `${process.env.REACT_APP_API_URL}/api/student/fee`
    return axios.post(url,{id:id},getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const upadateProfileDetail = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/update-profile-detail`
    return axios.post(url,body,getAuthHeader()).then((res) => {
        return res.data
    })
}

export const savePaymentDetail = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/student/save-fee-payment`
    return axios.post(url,body,getAuthHeader()).then((res) => {
        return res.data
    })
}

export const upayPaymentGateway = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/upay-payment`
    return axios.post(url,body,getAuthHeader()).then((res) => {
        return res.data
    })
}

export const nGeniusPaymentGateway = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/n-genius/get_url`
    return axios.post(url,body,getAuthHeader()).then((res) => {
        return res.data
    })
}

export const getTransactionsList = async(id) => {
    const url = `${process.env.REACT_APP_API_URL}/api/transaction`
    return axios.post(url,{student_id:id},getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const getFeeStructure = async() => {
    const url = `${process.env.REACT_APP_API_URL}/api/fee-structure`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const changePassword = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/change-password`
    return axios.post(url,body,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const batchOptions = async(countryId,classId,studyCenter,courseId) => {
    const url = `${process.env.REACT_APP_API_URL}/api/batch-option`
    return axios.post(url,{
        country_id:countryId,
        class_id:classId,
        study_center:studyCenter,
        course_id:courseId
    },getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const salesforceSendFormNumber=async(utmData)=>{
    // console.log('utmData...',utmData)
    let encdo_fno = encodeURIComponent(window.btoa(utmData.form_num !==undefined ? utmData.form_num : utmData));
    const url=`${process.env.REACT_APP_API_URL}/api/generateEnquiry?fno=${encdo_fno}&channel_name=${utmData.channel_name !==undefined ? utmData.channel_name :''}&current_channel_name=${utmData.current_channel_name !==undefined ? utmData.current_channel_name:''}&source=${utmData.source !==undefined?utmData.source:''}&lead_source=${utmData.lead_source !==undefined?utmData.lead_source:''}&campaign_name=${utmData.campaign_name !==undefined?utmData.campaign_name:''}&utm_adgroup=${utmData.utm_adgroup !==undefined?utmData.utm_adgroup:''}&utm_campaign=${utmData.utm_campaign !==undefined?utmData.utm_campaign:''}&utm_medium=${utmData.utm_medium !==undefined?utmData.utm_medium:''}&utm_source=${utmData.utm_source !==undefined?utmData.utm_source:''}&utm_term=${utmData.utm_term !==undefined?utmData.utm_term:''}&is_login=${utmData.is_login !==undefined?utmData.is_login:''}&status=${utmData.status !==undefined?utmData.status:''}`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data
    })
}

export const cashWinnerBankDetail=async(body)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/txCashPrizeStore`
    return axios.post(url,body).then((res)=>{
        return res.data
    })
}

export const getCashWinnerBankDetailStatus=async(fno)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/txCashPrizecheck`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data 
    })
}

export const getCashWinnertxCashPrizeeligible=async(fno)=>{
    const url=`${process.env.REACT_APP_API_URL}/api/txCashPrizeeligible`
    return axios.get(url,getAuthHeader()).then((res)=>{
        return res.data 
    })
}

export const studyMaterialMastercardSavePayment = async(body) => {
    const url = `${process.env.REACT_APP_API_URL}/api/studymaterial/mastercard/storeInfo`
    return axios.post(url,body,getAuthHeader()).then((res) => {
        return res.data
    })
}
